import { rem } from 'polished';
import styled from 'styled-components';

import { IStyledLabelProps } from '../TextInput/TextInput.types';
import { IStyledWrapperProps } from './DropDownInput.types';

export const StyledLabel = styled.label<IStyledLabelProps>`
  position: absolute;
  top: ${rem('30px')};
  left: 0;
  color: ${({ theme }) => theme.colors.cross.deepBlu};
  font-size: 1em;
  line-height: 1.4;
  pointer-events: none;
  font-weight: 700;

  :after {
    content: ${({ required }) => {
      return `'${required ? '*' : ''}'`;
    }};
    color: red;
    bottom: 4px;
    position: absolute;
  }
`;

export const StyledWrapper = styled.div<IStyledWrapperProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  padding-top: 1.8em;
  padding-bottom: 1.25em;
  flex: 1;
  ${({ inputValue }) =>
    !!inputValue &&
    `
    ${StyledLabel} {
      top: 0;
    }
  `}

  ${({ isActive }) =>
    isActive &&
    `
    ${StyledLabel} {
      top: 0;
    }
  `}
`;

export const StyledHelperTextWrapper = styled.div`
  display: flex;
  gap: ${rem('8px')};
  align-items: center;
  margin-top: ${rem('8px')};
`;

export const StyledHelperText = styled.p`
  font-size: ${rem('14px')};
  line-height: 1.4;
  pointer-events: none;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.cross.grayson};
  margin: 0;
`;
